import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';
import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: { // Exercise num
    unit: 'Unit 12',
    id: 'SB3-U12-P86-E1',
    audio: '',
    video: '',
    component: Circle_Write,
    exerciseKey: 'img/FriendsPlus/Page86/E1/Key/answerKey.png',
    titleQuestion: [{ num: '1', title: 'Circle the odd-one-out. Write.', color: "#1F4199" }],
    question: {
      Write: {
        inputStyle: { width: 200, marginLeft: 20, color: '#00a8ec' },
        answers: ['donkey', 'photo', 'goose'],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: { margin: '5px', border: 'solid 2px', borderColor: 'black', borderRadius: 10, padding: '0 5px', backgroundColor: 'white' },
        selectWordStyle: { borderColor: '#00a8ec' },
        limitSelect: 1,
        listWords: [
          'good wet bad donkey', //0
          'photo slow quiet loud', //1
          'loud quiet goose fast', //2
        ],
        answers: ['0-6', '1-0', '2-4'],
        initialValue: [],
      },
      Layout: `
        <div style='background-color: rgb(232,247,253); padding: 20px;'>
          <div style='margin: 5px;'><b>1</b>
            <span style='margin: 10px 20px; border: 2px solid black; border-radius: 10px; padding: 5px 10px; background-color: white;'>cow</span>
            <span style='margin: 10px 20px; border: 2px solid black; border-radius: 10px; padding: 5px 10px; background-color: white;'>goat</span>
            <span style='margin: 10px 20px; border: 2px solid black; border-radius: 10px; padding: 5px 10px; background-color: white;'>horse</span>
            <span style='margin: 10px 20px; border: 2px solid rgb(0, 168, 236); border-radius: 10px; padding: 5px 10px; background-color: white;'>floor</span>
            <span>&ensp;<u style='text-decoration-color: black;color:rgb(0,168,236)'>&emsp;floor&emsp;</u></span>
          </div>
          <div><span style='display:flex;justify-content: space-between; width: 700px;align-items: center;'><b>2</b> <input id='0' type='Circle' /> <input id='0' /></span> </div>
          <div><span style='display:flex;justify-content: space-between; width: 700px;align-items: center;'><b>3</b> <input id='1' type='Circle' /> <input id='1' /></span> </div>
          <div><span style='display:flex;justify-content: space-between; width: 700px;align-items: center;'><b>4</b> <input id='2' type='Circle' /> <input id='2' /></span> </div>
        </div>
      `,
    },
  },
  2: { // Exercise num
    unit: 'Unit 12',
    id: 'SB3-U12-P86-E2',
    audio: '',
    video: '',
    component: Circle_Write,
    exerciseKey: 'img/FriendsPlus/Page86/E2/Key/answerKey.png',
    titleQuestion: [{ num: '2', title: 'Look and circle the correct word.', color: "#1F4199" }],
    question: {
      Write: {
        // checkUppercase: true,
        inputStyle: {},
        answers: [],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: { fontWeight: 'bold' },
        selectWordStyle: { border: 'solid 2px', borderColor: '#00a8ec', borderRadius: '50%', padding: 3 },
        limitSelect: 1,
        listWords: [
          'smaller / bigger', //0
          'faster / slower', //1
          'faster / slower', //2
        ],
        answers: ['0-4', '1-4', '2-0'],
        initialValue: [],
      },
      Layout: `
        <img src="img/FriendsPlus/Page86/E2/1.jpg" style="width: 100%">
        <div style='display: flex; flex-direction: row;position: relative;'>
          <div style='flex: 3'>
            <div><b>1</b>&nbsp;The girl is <span style='font-weight: bold;'><span style="border: 2px solid rgb(0, 168, 236);padding: 3px;border-radius: 50%;">taller.</span> / shorter</span> than her brother.</div>
            <div><b>2</b>&nbsp;Her coat is <input id='0' type='Circle' /> than his coat.</div>
            <div><b>3</b>&nbsp;She is <input id='1' type='Circle' /> than her brother.</div>
            <div><b>4</b>&nbsp;The boy is <input id='2' type='Circle' /> than his sister.</div>
          </div>
        </div>
      `,
    },
  },
  3: { // Exercise num
    unit: 'Unit 12',
    id: 'SB3-U12-P86-E3',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: 'img/FriendsPlus/Page86/E3/1.jpg' }]],
  },
}

export default json;